import { render, staticRenderFns } from "./authenticate.vue?vue&type=template&id=54041fd9&scoped=true&"
import script from "./authenticate.vue?vue&type=script&lang=js&"
export * from "./authenticate.vue?vue&type=script&lang=js&"
import style0 from "./authenticate.vue?vue&type=style&index=0&id=54041fd9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54041fd9",
  null
  
)

export default component.exports